import { Controller } from "@hotwired/stimulus";
import { Turbo } from "@hotwired/turbo-rails";

export default class extends Controller {
  connect() {
    if (document.documentElement.hasAttribute("data-turbo-preview")) return;

    // The visit acknowledges publications server-side. A cached previous page
    // would otherwise resurrect its old unread link when the user presses Back.
    Turbo.cache.clear();
  }
}
